export default "/help-portal/on-site";
